<!-- Wrapper: aquí se pega classModal del padre -->
<div [class]="'mpf-root ' + classModal">
  <!-- Overlay -->
  <div class="mpf-overlay" (click)="eventoCerrarModal()"></div>

  <!-- Panel -->
  <div class="mpf-panel" (click)="$event.stopPropagation()">

    <!-- ✅ Header mobile (se oculta en desktop por CSS) -->
    <div class="mpf-mobile-header">
      <span class="mpf-mobile-title">Estados</span>
      <button type="button" class="mpf-mobile-close" (click)="eventoCerrarModal()">✕</button>
    </div>

    <!-- 3 estados visibles de frente -->
    <div class="mpf-list">
      <button type="button" class="mpf-item" (click)="setStatus(1); eventoCerrarModal()">
        <span class="mpf-dot mpf-dot--activo"></span>
        <span class="mpf-text">Activo</span>
      </button>

      <button type="button" class="mpf-item" (click)="setStatus(2); eventoCerrarModal()">
        <span class="mpf-dot mpf-dot--ausente"></span>
        <span class="mpf-text">Ausente</span>
      </button>

      <button type="button" class="mpf-item" (click)="setStatus(0); eventoCerrarModal()">
        <span class="mpf-dot mpf-dot--desconectado"></span>
        <span class="mpf-text">Desconectado</span>
      </button>
    </div>
  </div>
</div>


